<template>
    <div class="solution-details"
         v-bind:class="{'visible-detail-mob':visibleMobileBigScreen}"
    >


        <div class="h3">
                 <span class="viewdetail"
                       v-bind:class="{'visible-detail':visibleDetail}"
                       @click="showVisibleList()"
                 ></span>
            <span class="title"
                  @click="showVisibleList()"
            >
                    {{curentSolution.title}}
            </span>
            <div class="arrows">
                <span class="before"
                      v-on:click="solutionActivateBefore"
                ></span>
                <span class="next"
                      v-on:click="solutionActivateNext"
                ></span>
            </div>

        </div>
        <div class="fadeblock">
            <transition name="fade">
                <div class="info"
                     v-if="visibleDetail"
                >
                    <div class="considerations"
                         v-if="curentSolution.business_problem"
                    >
                        <h4>Business problem</h4>
                        <div class="description"
                             v-html="curentSolution.business_problem"
                        >
                        </div>
                    </div>


                    <div class="strategic"
                         v-if="curentSolution.strategic"
                    >
                        <h4>Resolution:</h4>
                        <ul>
                            <li
                                v-for="service in curentSolution.strategic"
                                :key="service.id"
                            >
                                <div v-html="service.pol_strand_to_future_success"></div>
                                <div v-html="service.how_this_translates_to_it_support"></div>
                                <div v-html="service.where_computacenter_will_help"></div>
                                <div v-html="service.focus_areas"></div>
                            </li>

                        </ul>
                    </div>








                    <div class="considerations"
                         v-if="curentSolution.postmaster"
                    >
                        <h4>Impact:</h4>
                    </div>
                    <div class="sublist">
                        <div class="considerations"
                             v-if="curentSolution.postmaster"
                        >
                            <h6>Postmaster</h6>
                            <div class="description"
                                 v-html="curentSolution.postmaster"
                            >
                            </div>
                        </div>


                        <div class="considerations"
                             v-if="curentSolution.customer"
                        >
                            <h6>Customer</h6>
                            <div class="description"
                                 v-html="curentSolution.customer"
                            >
                            </div>
                        </div>

                        <div class="considerations"
                             v-if="curentSolution.pol"
                        >
                            <h6>POL</h6>
                            <div class="description"
                                 v-html="curentSolution.pol"
                            >
                            </div>
                        </div>
                    </div>



                    <div class="strategic"
                         v-if="curentSolution.strategic"
                    >
                        <h4>Strategic Alignments:</h4>
                        <ul>
                            <li
                                v-for="service in curentSolution.strategic"
                                :key="service.id"
                            >
                                <div>
                                    <img class="icon"
                                         :src="service.icon"
                                    >

                                </div>
                                <h6 v-html="service.name"></h6>
                            </li>

                        </ul>
                    </div>

                    <!--<div class="image"-->
                    <!--v-if="curentSolution.image"-->
                    <!--&gt;-->
                    <!--<img class="photo"-->
                    <!--:src="curentSolution.image"-->
                    <!--/>-->
                    <!--</div>-->
                    <!--<div class="description"-->
                    <!--v-html="curentSolution.environment_specific_use"-->
                    <!--&gt;-->
                    <!--</div>-->

                    <!--<div class="considerations"-->
                    <!--v-if="curentSolution.considerations"-->
                    <!--&gt;-->
                    <!--<h4>Considerations</h4>-->
                    <!--<ul>-->
                    <!--<li-->
                    <!--v-for="consideration in curentSolution.considerations"-->
                    <!--&gt;-->
                    <!--{{consideration}}-->
                    <!--</li>-->

                    <!--</ul>-->
                    <!--</div>-->

                    <!--<div class="services"-->
                    <!--v-if="curentSolution.services"-->
                    <!--&gt;-->
                    <!--<h4>Supporting Services</h4>-->
                    <!--<ul>-->
                    <!--<li-->
                    <!--v-for="service in curentSolution.services"-->
                    <!--&gt;-->
                    <!--<div>-->
                    <!--<img class="icon"-->
                    <!--:src="imageSrc(service.slug)"-->
                    <!--&gt;-->
                    <!--<span> {{service.name}}</span>-->
                    <!--</div>-->
                    <!--</li>-->

                    <!--</ul>-->
                    <!--</div>-->

                    <!--<div class="intel tech-details"-->
                    <!--v-if="curentSolution.intel_sol"-->
                    <!--&gt;-->
                    <!--<h3>-->
                    <!--<img src="/assets/images/icons/intel.svg"/>-->
                    <!--Solutions-->
                    <!--</h3>-->
                    <!--<div class="intel-items"-->
                    <!--v-for="intel_solition in curentSolution.intel_sol"-->
                    <!--&gt;-->
                    <!--<div v-if="intel_solition.logo">-->
                    <!--<img-->
                    <!--:src="intel_solition.logo"-->
                    <!--/>-->
                    <!--</div>-->

                    <!--<h4 class="title"-->
                    <!--v-html="intel_solition.title"-->
                    <!--&gt;</h4>-->
                    <!--<div class="description"-->
                    <!--v-html="intel_solition.description"-->
                    <!--&gt;-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
            </transition>
            <transition name="fade">
                <div class="list"
                     v-if="!visibleDetail"
                >
                    <div class="sponsorpage">
                        <div class="button">
                            <a class="computa"
                               v-on:click="$emit('setShowPage','computacenter-page')"
                            >
                                <img src="@/assets/images/icons/compitacenter.svg"/>
                            </a>
                        </div>
                        <div class="button">
                            <a class="intel"
                               v-on:click="$emit('setShowPage','intel-page')"
                            >
                                <img src="@/assets/images/icons/post-office-white.svg"/>
                            </a>
                        </div>
                    </div>
                    <ul>
                        <li
                            v-for="solution in solutionList"
                            :key="solution.id"
                            @click="solutionActivate(solution.id)"
                            @mouseover="$emit('setHoverSolution',solution.id)"
                            @mouseleave="$emit('setHoverSolution',false)"
                        >
                            {{solution.title}}
                        </li>

                    </ul>

                </div>
            </transition>
        </div>


    </div>
</template>

<script>
    export default {
        name: "SolutionDetails",
        props: ['curentSolution', 'curentEnvironment', 'displayType'],
        data() {
            return {
                visibleMobileBigScreen: false,
                visibleDetail: true,
                // visibleDetailMob: false,
                // visibleListlMob: false,
            }
        },
        computed: {
            solutionList: function () {
                let sol = [];
                if (Object.prototype.hasOwnProperty.call(this.curentEnvironment, "solutions")) {
                    this.curentEnvironment.solutions.forEach((item) => {
                        sol.push(this.globalData.solutions[item.id])
                    });
                }

                return sol;
            }
        },
        methods: {
            solutionActivateNext() {
                let curel = 0;
                this.curentEnvironment.solutions.forEach((item, i) => {
                    if (item.id == this.curentSolution.id) {
                        curel = i;
                    }
                });
                if (curel + 2 > this.curentEnvironment.solutions.length) {
                    curel = 0;
                } else {
                    curel = curel + 1;
                }
                this.solutionActivate(this.curentEnvironment.solutions[curel].id)

            },
            solutionActivateBefore() {
                let curel = 0;
                this.curentEnvironment.solutions.forEach((item, i) => {
                    if (item.id == this.curentSolution.id) {
                        curel = i;
                    }
                });
                curel = curel - 1;
                if (curel < 0) {
                    curel = this.curentEnvironment.solutions.length - 1;
                }
                this.solutionActivate(this.curentEnvironment.solutions[curel].id)
            },
            solutionActivate(sol_id) {
                this.visibleDetail = true;
                this.$emit('solutionActivate', sol_id);
            },
            imageSrc(src) {
                return './assets/images/icons/services/' + src + '.svg'
            },
            onHover() {
                this.$emit('')
            },
            // showMobileDetail(status = null) {
            //     this.visibleDetail = !this.visibleDetail
            //     this.visibleDetailMob = this.visibleDetail
            //     this.visibleMobileBigScreen = this.visibleDetailMob
            //     this.$emit('setVisibleDetailMob', this.visibleMobileBigScreen)
            //
            // },
            showVisibleList() {
                this.visibleDetail = !this.visibleDetail
                // this.visibleListlMob = false;
            },

        }
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>